var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-' + _vm.fieldResolved.component,{tag:"component",attrs:{"field":_vm.fieldResolved,"model":_vm.modelResolved,"form":_vm.formResolved,"layout":_vm.layout,"layout-class":_vm.layoutClass},on:{"input":_vm.input}})}
var staticRenderFns = []

export { render, staticRenderFns }